// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ProductUnitOfMeasure extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  static Types = {
    Ton: 1,
    Yard: 2,
    Each: 3,
    Ounce: 4,
    Pound: 5,
    Load: 6,
    Hour: 7,
    GL: 8
  }
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  abbreviation?: string;
  created!: Date;
  createdBy?: string;
  deleted?: Date;
  deletedBy?: string;
  displayOrder?: number;
  name?: string;
  poundsMultiplier?: number;
  quantityBasedUnit!: boolean;
  volumeBasedUnit!: boolean;
  weightBasedUnit!: boolean;
}

